import React, { useEffect, useState } from 'react';
import Select, { components } from 'react-select';
import { MasterService } from '../../services';
// import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
// import ReactMultiSelectCheckboxes from '../../library_modules/react-multiselect-checkboxes/lib';
import ReactMultiSelectCheckboxes from "../common/ReactMultiSelectCheckboxes"
import { Calendra, Calendra2 } from './DatePicker'
import { getFirstDate } from '../../config/helper';
const { ValueContainer, Placeholder } = components;
const CustomValueContainer = ({ children, ...props }) => {
    return (
        <ValueContainer {...props}>
            <Placeholder {...props} isFocused={props.isFocused}>
                {props.selectProps.placeholder}
            </Placeholder>
            {React.Children.map(children, child =>
                child && child.type !== Placeholder ? child : null
            )}
        </ValueContainer>
    );
};


const RolesOptions = [
    { id: '6', label: 'SO' },
    { id: '5', label: 'SM' },
    { id: '4', label: 'TH' },
    { id: '3', label: 'NSH' }

]

const AttendanceStatusOptions = [
    { id: 'P', label: 'Present' },
    { id: 'A', label: 'Absent' },
    { id: 'L', label: 'Leave' },
]

const AttendanceReportTopFilter = (props) => {
    const [fromDate, setFromDate] = useState(getFirstDate(new Date()));
    const [toDate, setToDate] = useState(new Date());
    const [selectedRole, setSelectedRole] = useState("")
    const [users, setUsers] = useState([]);
    const [selectedAttendanceStatus, setSelectedAttendanceStatus] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([])
    const [userSearchText, setUserSearchText] = useState("")

    useEffect(() => {
        if (props.isReset) {
            handleReset()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.isReset])


    const handleChange = (event, name) => {

        if (name === "from_date") {
            setFromDate(event)
        }
        if (name === "to_date") {
            setToDate(event)
            if (new Date(event).getTime() <= new Date(fromDate).getTime()) {
                setFromDate(null)
            }
        }

        if (name === 'role') {
            setSelectedRole(event)
            getUsersByRole(event.id, userSearchText)
            setSelectedUsers([])
        }


    };

    const handleChangeMultiSel = (field_name, field_obj, event) => {
        let selected_value = []
        if (event.action === "select-option" && event.option.value === "*") {
            selected_value = field_name === "attendance_status" ? [{ label: "Select All", value: "*" }, ...AttendanceStatusOptions] : [{ label: "Select All", value: "*" }, ...selectedAttendanceStatus]

            if (field_name === "users") {
                selected_value = field_name === "users" ? [{ label: "Select All", value: "*" }, ...users] : [{ label: "Select All", value: "*" }, ...selectedUsers]
            }
        } else if (event.action === "deselect-option" && event.option.value === "*") {
            selected_value = []
        } else if (event.action === "deselect-option" && event.option.value !== "*") {
            selected_value = field_obj.filter((o) => o.value !== "*")

        } else {
            selected_value = field_obj
        }

        if (field_name === "attendance_status") {
            setSelectedAttendanceStatus(selected_value);
        }

        if (field_name === "users") {
            setSelectedUsers(selected_value);
        }

    }

    const handleSearch = (is_reset) => {
        if (is_reset) {
            let params = {
                start_date: getFirstDate(new Date()),
                end_date: new Date(),
                manager_id_filter: [],
                attendance_status_filter: [
                    "P",
                    "A",
                    "L"
                ],
                page: 1,
            }
            props.getAttendanceData(1, params, true)
        } else {
            let params = {
                start_date: fromDate,
                end_date: toDate,
                manager_id_filter: selectedUsers.map(v => v.id).filter(function (element) {
                    return element !== undefined;
                }),
                attendance_status_filter: selectedAttendanceStatus.map(v => v.id).filter(function (element) {
                    return element !== undefined;
                }),
                manager_filter_role_id: selectedRole.id,
                page: 1,
            }

            props.getAttendanceData(1, params, true) //need to do work
        }
    }

    const handleReset = () => {
        setFromDate(getFirstDate(new Date()))
        setToDate(new Date())
        handleSearch(true)
        setSelectedRole("");
        setSelectedUsers([]);
        setSelectedAttendanceStatus([])
        setUserSearchText("")
    }

    const getUsersByRole = async (role_id, search_text = "") => {
        const userIds = selectedUsers.map(v => v.id).filter(Boolean);
        MasterService.post('/sfa/user/get-users', { role_id, search_text, page_no: 1, page_limit: 500, userIds })
            .then(function (response) {
                if (response.data.status === 200) {
                    let reporting_manager_list = response.data.data.user_list.map(elm => ({ id: elm.id, label: elm.name, value: elm.name }));
                    setUsers(reporting_manager_list);
                }
            })
            .catch(function (response) {
            });
    }

    const handleUserSearchChange = (event) => {
        const value = event.target.value;
        setUserSearchText(value);
        if (selectedRole?.id) {
            getUsersByRole(selectedRole.id, value);
        }
    }

    return (
            <div className=''>
                <div className="visit-report-filter">
                    <fieldset className="rangepicker-calendra">
                        <div className="material">
                            <Calendra
                                placeholder={"Date From"}
                                defaultDate={fromDate}
                                endDate={toDate}
                                handleDateChange={(e) => handleChange(e, 'from_date')}
                            />
                        </div>
                    </fieldset>
                    <fieldset className="rangepicker-calendra">
                        <div className="material">
                            <Calendra2
                                placeholder={"To Date"}
                                startDate={fromDate}
                                defaultDate={toDate}
                                endDate={new Date()}
                                handleDateChange={(e) => handleChange(e, 'to_date')}
                            />
                        </div>
                    </fieldset>



                    <fieldset className="multiselect-dropDown col-md-4">
                        <div className="material">
                            {/* <ReactMultiSelectCheckboxes
                                isMulti
                                options={[{ label: "Select All", value: "*" }, ...AttendanceStatusOptions]}
                                placeholderButtonLabel="Status"
                                iconAfter="false"
                                getDropdownButtonLabel={getDropdownButtonLabel}
                                value={selectedAttendanceStatus?.length === AttendanceStatusOptions?.length ? [{ label: "Select All", value: "*" }, ...AttendanceStatusOptions] : selectedAttendanceStatus}
                                onChange={handleChangeMultiSel.bind(this, "attendance_status")}
                                getOptionLabel={({ label }) => label}
                                getOptionValue={({ id }) => id}
                            /> */}
                            <ReactMultiSelectCheckboxes
                                options={[{ label: "Select All", value: "*" }, ...AttendanceStatusOptions]}
                                value={selectedAttendanceStatus?.length === AttendanceStatusOptions?.length ? [{ label: "Select All", value: "*" }, ...AttendanceStatusOptions] : selectedAttendanceStatus}
                                onChange={handleChangeMultiSel.bind(this, "attendance_status")}
                                name="attendance_status"
                                // placeholder="Status*"
                                isDisabled={false}
                                isClearable={true}
                                getOptionLabel={({ label }) => label}
                                getOptionValue={({ id }) => id}
                            />
                        </div>
                    </fieldset>



                    <fieldset className="single-select">
                        <div className="material">
                            <Select
                                components={{ ValueContainer: CustomValueContainer }}
                                // components={{ IndicatorSeparator:() => null }}
                                // value={selectedRole}
                                value={RolesOptions.filter(e => e.id === selectedRole.id)}
                                onChange={(e) => handleChange(e, 'role')}
                                options={RolesOptions}
                                placeholder="Role"
                                className="react-select"
                                classNamePrefix="react-select"
                                getOptionLabel={({ label }) => label}
                                getOptionValue={({ id }) => id}
                                // menuIsOpen={true}
                            />
                        </div>
                    </fieldset>
                    <fieldset className="single-select">
                        <div className="material">
                            <input
                                type="text"
                                className="form-input"
                                placeholder=" "
                                value={userSearchText}
                                onChange={handleUserSearchChange}
                                disabled={!selectedRole?.id}
                            />
                            <label data-label="Search User (SFA ID / Name)" className="form-label"></label>
                        </div>
                    </fieldset>

                    <fieldset className="multiselect-dropDown col-md-4">
                        <div className="material">
                            {/* <ReactMultiSelectCheckboxes
                                isMulti
                                options={[{ label: "Select All", value: "*" }, ...users]}
                                placeholderButtonLabel="User"
                                iconAfter="false"
                                getDropdownButtonLabel={getDropdownButtonLabel}
                                value={selectedUsers?.length === users?.length ? [{ label: "Select All", value: "*" }, ...users] : selectedUsers}
                                onChange={handleChangeMultiSel.bind(this, "users")}
                                getOptionLabel={({ label }) => label}
                                getOptionValue={({ id }) => id}
                            /> */}
                            <ReactMultiSelectCheckboxes
                                options={[{ label: "Select All", value: "*" }, ...users]}
                                value={selectedUsers?.length === users?.length ? [{ label: "Select All", value: "*" }, ...users] : selectedUsers}
                                onChange={handleChangeMultiSel.bind(this, "users")}
                                name="users"
                                // placeholder="User*"
                                isDisabled={false}
                                isClearable={true}
                                getOptionLabel={({ label }) => label}
                                getOptionValue={({ id }) => id}
                            />
                        </div>
                    </fieldset>



                    <div className="btn-submit-reset">
                        <button type="submit" className="btn-primary" onClick={() => { handleSearch(false) }}>Update</button>
                        <button className="btn-reset" onClick={() => handleReset()}>Reset</button>
                    </div>
                </div>

            </div>
    )
}
export default AttendanceReportTopFilter;